import React, { forwardRef, useState, useMemo } from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { Btn } from '../../../atoms/button/Button';
import { Stack } from '../../../atoms/stack/Stack';
import AlternativeItem from '../../../molecules/system/alternativeItem/AlternativeItem';
import AlternativeItemsHidden from '../../../molecules/system/alternativeItem/AlternativeItemsHidden';
import AlternativeFilters from '../../../molecules/system/alternativeFilter/AlternativeFilters';

const AlternativesList = forwardRef(({ section, t }, ref) => {
  const [activeFilters, setActiveFilters] = useState({});

  const handleFilterChange = (updatedFilters) => {
    setActiveFilters(updatedFilters);
  };

  const showHiddenCallback = (category) => {
    showHidden[category] = showHidden[category] ? !showHidden[category] : true;
    setShowHidden({ ...showHidden });
  };

  const filteredData = useMemo(() => {
    if (Object.values(activeFilters).some((isActive) => isActive)) {
      return section.componentData.filter(
        (item) => activeFilters[item.categoryDbName]
      );
    } else {
      return section.componentData;
    }
  }, [section.componentData, activeFilters]);

  const [showHidden, setShowHidden] = useState({});

  return (
    <div
      ref={ref}
      className="flex w-full flex-col flex-1 lg:mx-auto max-w-6xl px-8 my-10 md:my-20 gap-32"
    >
      <AlternativeFilters
        filtersData={section.componentData}
        onFilterChange={handleFilterChange}
        t={t}
      />
      {filteredData.map((item) => (
        <Stack className="gap-3" key={item.id}>
          <div className="flex flex-col md:flex-row justify-between items-start gap-3 md:items-center">
            <Typography as="h5" fontVariant="h5" textAlign="left">
              {item.title}
            </Typography>
            {item.hasGuide && (
              <LinkButton
                label={t('common.trySystemGuide')}
                href={item.systemGuideHref}
                className="bg-[#FEC84B] !text-center min-w-max"
              />
            )}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {item.alternatives.map((alt) => (
              <AlternativeItem key={alt.id} data={alt} showMore t={t} />
            ))}
            {showHidden[item.categoryDbName] && (
              <>
                {item.hiddenAlternatives?.map((alt) => (
                  <AlternativeItem key={alt.id} data={alt} showMore t={t} />
                ))}
              </>
            )}
          </div>
          {item?.hiddenAlternatives?.length > 0 &&
            !showHidden[item.categoryDbName] && (
              <>
                <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:grid hidden">
                  <AlternativeItemsHidden data={item?.hiddenAlternatives} />
                </div>
                <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:hidden">
                  <AlternativeItemsHidden
                    data={[item?.hiddenAlternatives[0]]}
                  />
                </div>
                <div>
                  <Btn
                    text={t('common.showMore')}
                    className="bg-[#FEC84B] !text-center min-w-max"
                    onClick={() => {
                      showHiddenCallback(item.categoryDbName);
                    }}
                  />
                </div>
              </>
            )}
        </Stack>
      ))}
    </div>
  );
});

export default AlternativesList;
